export enum AtiraLinkPlanEmbed {
  PLAN_0 = 'off',
  PLAN_1 = 'off',
  PLAN_2 = 'unlimited',
}
